import { Button, Grid, Select, Table, Text, TextInput, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconDeviceFloppy, IconPlus, IconTrash } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDebounce } from '../../Hooks/useDebounce';
import { deleteAllocation, updatePoAndStyle } from '../../api/allocation';
import { getPono } from '../../api/poList';
import { saveFloorData, updateAllocation } from '../../api/saveFloorData';
import { getAllocationList } from '../../api/styleList';
import NavBar from '../../components/NavBar/NavBar';
import { STORES } from '../../constants/stores';
import { AllocationData } from '../../interface/Allocation';
import { PoNoWithStatus } from '../../interface/AllocationInvoice';
import '../Global.css';
import classes from './ModifyAllocation.module.css';


const ModifyAllocation: React.FC = () => {
    const [poNoList, setPoNoList] = useState<any[]>([]);
    const [styleList, setStyleList] = useState<any[]>([]);
    const [allocation, setAllocation] = useState<AllocationData>();
    const [allocationData, setAllocationData] = useState<any[]>([]);
    const [po, setPo] = useState<{ poNo: string, poId: string }>({ poNo: '', poId: '' });
    const poSearch = useDebounce(po.poNo, 700);
    const token = useSelector((state: any) => state.user.sessionId);
    const [poTable, setPoTable] = useState<any[]>();
    const theme = useMantineTheme();
    const isMobile = useMediaQuery("(min-width: 0) and (max-width: 550px)") || false;
    const isTablet = useMediaQuery("(min-width: 551px) and (max-width: 1198px)") || false;
    const isDesktop = useMediaQuery("(min-width: 1199px)") || false;
    const [sizeData, setSizeData] = useState<{ size: string | undefined, quantity: number | undefined, index: number | -1 }>({
        size: undefined,
        quantity: undefined,
        index: -1
    });
    const [store, setStore] = useState<{ store: string, index: number | undefined }>();
    console.log('Allocation: ', allocation);
    const getPo = async () => {
        const poList = await getPono(token, po?.poNo);
        if (poList) {
            setPoNoList(poList?.data?.map((item: PoNoWithStatus) => {
                return {
                    label: item.poNo,    // Use `item.poNo` for the label
                    value: item.poId!.toString(),  // Convert `poId` to string for the value
                };
            }))
        }
    }

    useEffect(() => {
        getPo();
    }, [poSearch]);


    const setPoTableData = async (data: any) => {
        setPoTable(data.map((item: any) => {
            return {
                styleNo: item.style_no,
                status: item.allocation_status.some((value: boolean) => value === false) ? 'Pending' : 'Done'
            }
        }));
    }

    const handleStyleChange = async (value: string | null) => {
        if (value) {
            setAllocation(allocationData.find((item: any) => item.style_id === parseInt(value)))
        }
    }

    const handlePoNoChange = async (value: string | null) => {
        if (value) {
            setPo({ poId: value?.toString() || '', poNo: poNoList.find((item: any) => item.value === value).label });
            const allocations = await getAllocationList(token, parseInt(value));
            setAllocationData(allocations);
            setPoTableData(allocations);
            if (allocations) {
                setStyleList(allocations.map((item: any) => {
                    return {
                        label: item.style_no,
                        value: item.style_id.toString()
                    }
                }))
            }
        }
    }

    // Store change
    const handleStoreChange = async (storeValue: string) => {
        if (storeValue && storeValue !== '') {
            setStore({ store: storeValue || '', index: allocation?.storeName?.length });
            let storeIndex = STORES.indexOf(storeValue);
            while (storeIndex >= 0) {
                let prvStore = STORES[storeIndex - 1];
                let i = allocation?.storeName?.indexOf(prvStore) as number;
                if (i !== -1) {
                    setStore({ store: storeValue || '', index: i + 1 })
                    break;
                }
                if (storeIndex === 0) {
                    setStore({ store: storeValue || '', index: 0 })
                    break;
                }
                storeIndex--;
            }
        }
    }

    // Add store
    const handleAddStore = async () => {
        try {
            if (allocation && store?.store && store.index !== undefined) {
                if (allocation?.storeName?.includes(store?.store)) {
                    alert('Store already exists.');
                    return;
                }
                let newStores = allocation?.storeName?.splice(store.index, 0, store.store);
                let newQuantities = allocation.sizeQuantities?.splice(store.index, 0, (allocation.receivedQty ?? []).map((item: { size: string, quantity: number }) => {
                    return {
                        size: item.size,
                        quantity: 0
                    }
                }));
                let newInitial = allocation.initial?.splice(store.index, 0, 'SVP');
                let newStatus = allocation.allocation_status?.splice(store.index, 0, false);
                const response = await saveFloorData(token, allocation);
                if (response.data) {
                    setAllocation(response.data);
                    return;
                } else {
                    alert('Could not update data.');
                }
            } else {
                alert('Please select the store')
            }
        } catch (error) {
            console.log('Error Updating data:', error)
        }
    }

    // Delete store
    const handleDeleteStore = async (store: string, index: number) => {
        const confirm = window.confirm(`Do you want to delete ${store}`);
        if (confirm) {
            try {
                if (allocation && store && index !== undefined) {
                    if (!allocation?.storeName?.includes(store)) {
                        alert('Store does not exists.');
                        return;
                    }
                    let newStores = allocation?.storeName?.splice(index, 1);
                    let newQuantities = allocation.sizeQuantities?.splice(index, 1);
                    let newInitial = allocation.initial?.splice(index, 1);
                    let newStatus = allocation.allocation_status?.splice(index, 1);
                    let newTotalAllocationPerSize = allocation?.totalAllocationPerSize?.map((group: any, idx: number) =>
                        allocation?.sizeQuantities?.reduce((total: number, item: any) => total + item[idx].quantity, 0)
                    );

                    const response = await saveFloorData(token, {
                        ...allocation,
                        totalAllocationPerSize: newTotalAllocationPerSize,
                    });
                    if (response.data) {
                        setAllocation(response.data);
                        return;
                    } else {
                        alert('Could not update data.');
                    }
                } else {
                    alert('Please select the store')
                }
            } catch (error) {
                console.log('Error Updating data:', error)
            }
        }
    }

    // Add size
    const handleAddSize = async () => {
        if (
            !sizeData.size ||
            sizeData.quantity === undefined ||
            sizeData.quantity === null ||
            !allocation?.receivedQty
        ) {
            alert("Please enter size details properly.");
            return;
        }

        if (
            sizeData.index < 1 ||
            sizeData.index > allocation.receivedQty.length + 1
        ) {
            alert("Enter proper index.");
            return;
        }

        if (!allocation?.totalAllocationPerSize) {
            alert("Allocation not found.");
            return;
        }

        const existing = allocation.receivedQty.some(
            (item: { size: string }) =>
                item.size.toLowerCase() ===
                sizeData?.size?.toLowerCase()
        );

        if (existing) {
            alert("Size already exists.");
            return;
        }

        try {
            const insertIndex = sizeData.index - 1;

            /* -----------------------------------------
               RECEIVED QTY
            ----------------------------------------- */

            const newReceivedQty = [
                ...allocation.receivedQty.slice(0, insertIndex),

                {
                    size: sizeData.size,
                    quantity: Number(sizeData.quantity),
                },

                ...allocation.receivedQty.slice(insertIndex),
            ];

            /* -----------------------------------------
               PICKED QTY
    
               IMPORTANT:
               New sizes always start at 0 picked.
            ----------------------------------------- */

            const newPickedQty = [
                ...(allocation.pickedQty || []).slice(
                    0,
                    insertIndex
                ),

                {
                    size: sizeData.size,
                    quantity: 0,
                },

                ...(allocation.pickedQty || []).slice(
                    insertIndex
                ),
            ];

            /* -----------------------------------------
               STORE ALLOCATION
    
               Add the new size to every store,
               allocation starts at 0.
            ----------------------------------------- */

            const newSizeQuantities =
                allocation?.sizeQuantities?.map(
                    (storeSizes: any[]) => [
                        ...storeSizes.slice(0, insertIndex),

                        {
                            size: sizeData.size,
                            quantity: 0,
                        },

                        ...storeSizes.slice(insertIndex),
                    ]
                );

            /* -----------------------------------------
               TOTAL ALLOCATION PER SIZE
            ----------------------------------------- */

            const newTotalAllocationPerSize = [
                ...allocation.totalAllocationPerSize.slice(
                    0,
                    insertIndex
                ),

                0,

                ...allocation.totalAllocationPerSize.slice(
                    insertIndex
                ),
            ];

            /* -----------------------------------------
               OVERSTOCK
    
               Received - Allocated
    
               Since allocation starts at 0,
               overstock initially equals received qty.
            ----------------------------------------- */

            const newOverstockPerSize = [
                ...(allocation.overstockPerSize || []).slice(
                    0,
                    insertIndex
                ),

                Number(sizeData.quantity),

                ...(allocation.overstockPerSize || []).slice(
                    insertIndex
                ),
            ];

            /* -----------------------------------------
               TOTAL RECEIVED
            ----------------------------------------- */

            const newTotal = newReceivedQty.reduce(
                (
                    total: number,
                    item: { quantity: number }
                ) => total + Number(item.quantity || 0),
                0
            );

            /* -----------------------------------------
               BUILD NEW OBJECT
            ----------------------------------------- */

            const updatedAllocation = {
                ...allocation,

                receivedQty: newReceivedQty,

                pickedQty: newPickedQty,

                sizeQuantities: newSizeQuantities,

                totalAllocationPerSize:
                    newTotalAllocationPerSize,

                overstockPerSize:
                    newOverstockPerSize,

                total: newTotal,
            };

            /* -----------------------------------------
               SAVE
            ----------------------------------------- */

            const response = await updateAllocation(
                token,
                updatedAllocation
            );

            if (response?.data) {
                setAllocation(response.data);

                alert("Size added successfully.");

                return;
            }

            alert("Could not update data.");
        } catch (error) {
            console.error(
                "Something went wrong while adding size.",
                error
            );

            alert("Something went wrong while adding size.");
        }
    };

    // Delete size
    const handleDeleteSize = async (size: string, quantity: number, index: number) => {
        if (allocation?.receivedQty?.length === 1) return alert('Cannot delete last size.')
        if (size && quantity && allocation?.receivedQty) {
            try {
                if (allocation && allocation.totalAllocationPerSize?.length) {
                    let newSizeQuantities = allocation.sizeQuantities;
                    newSizeQuantities = newSizeQuantities?.map((item: any) => {
                        return item.splice(index, 1);
                    });
                    let newTotal = allocation.total || 0 - quantity;
                    let newReceivedQty = allocation.receivedQty?.splice(index, 1);
                    let newPickedQty = allocation.pickedQty?.splice(index, 1);
                    let newTotalAllocationPerSize = allocation.totalAllocationPerSize?.splice(index, 1);
                    let newOverstockPerSize = allocation.overstockPerSize?.splice(index, 1);
                    const response = await updateAllocation(token, allocation);
                    if (response.data) {
                        setAllocation(response.data);
                        return;
                    } else {
                        alert('Could not update data.');
                    }
                } else {
                    alert('Allocation not found.')
                }
            } catch (error) {
                console.log('Something went wrong', error);
            }
        } else {
            alert('Please enter size detials properly');
        }
    }

    const handleSave = async () => {
        const po_id = allocation?.allocation_po_id as number;
        const styl_id = allocation?.style_id as number;
        const po_no = allocation?.po_no as string;
        const style_no = allocation?.style_no as string;
        try {
            const update = await updatePoAndStyle(token, po_id, styl_id, po_no, style_no);
            const updateAllocationData = await updateAllocation(token, allocation);
            if (update && updateAllocationData) {
                alert('Allocation updated successfully.');
            }
            return;
        } catch (error) {
            console.log('Error updating Pono and StyleNo.');
        }
    }

    const handleEditSize = async (size: string, index: number) => {
        // change size name
        if (size !== '') {
            // change size in allocation table
            let newSizeQuantities = allocation?.sizeQuantities;
            let newReceivedQty = allocation?.receivedQty;
            let newStyleReceivedQty = allocation?.style_receivedQty;
            if (newSizeQuantities && newReceivedQty && newStyleReceivedQty) {
                newSizeQuantities.map((item: any) => (item[index].size = size));
                newReceivedQty[index].size = size;
                newStyleReceivedQty[index].size = size;
                setAllocation(prev => ({ ...prev, sizeQuantities: newSizeQuantities, receivedQty: newReceivedQty, style_receivedQty: newStyleReceivedQty || [] }));
            }
        }
    }

    const handleDelete = async () => {
        const confirm = window.confirm('Are you sure you want to delete this allocation?');
        if (!confirm) return;
        try {
            const deletedAllocation = await deleteAllocation(token, allocation?.allocation_id as number);
            if (deletedAllocation === true) {
                setStyleList(styleList.filter((item: any) => item.style_id !== allocation?.style_id));
                setAllocationData(allocationData.filter((item: any) => item.allocation_id !== allocation?.allocation_id));
                setAllocation(undefined);
                alert('Allocation deleted successfully.');
                return;
            }
            return;
        } catch (error) {
            console.log('Error deleting allocation:', error);
        }
    }

    return (
        <div>
            <NavBar />
            <div className={'main'}>
                <h2 className={'title'}>Modify Allocation</h2>
                <div style={{ width: '100%', marginBottom: '50px' }}>
                    <Grid >
                        <Grid.Col offset={isDesktop ? 2 : undefined} span={isDesktop ? 3 : isTablet ? 4 : 12}>
                            <div className={classes.gridRowDiv} >
                                {/* <Text className={classes.textWithInput}>Po No:</Text> */}
                                <Select
                                    data={poNoList}
                                    label='Po No'
                                    placeholder="Select Po No"
                                    style={{ flexGrow: 1 }}
                                    className={classes.selectDiv}
                                    searchable
                                    clearable
                                    onChange={handlePoNoChange}
                                    onSearchChange={(e) => setPo({ ...po, poNo: e.toUpperCase() })}
                                    onClear={() => {
                                        setPo({ poId: '', poNo: '' })
                                        setAllocation(undefined);
                                    }}
                                />
                            </div>
                        </Grid.Col>
                        <Grid.Col span={isDesktop ? 3 : isTablet ? 4 : 12}>
                            <div className={classes.gridRowDiv} >
                                {/* <Text className={classes.textWithInput}>Style No:</Text> */}
                                <Select
                                    data={styleList}
                                    label='Style No'
                                    placeholder="Select Style No"
                                    style={{ flexGrow: 1 }}
                                    className={classes.selectDiv}
                                    searchable
                                    clearable
                                    onChange={handleStyleChange}
                                    onClear={() => {
                                        setAllocation(undefined);
                                    }}
                                />
                            </div>
                        </Grid.Col>
                        <Grid.Col span={isMobile ? 12 : 2}>
                            {allocation && (<Button style={{ marginTop: '25px' }} variant='outline' className={classes.trashIcon} onClick={handleDelete}><IconTrash />Delete Allocation</Button>)}
                        </Grid.Col>
                    </Grid>
                    {allocation && (<div>
                        <Grid style={{ padding: '20px' }}>
                            <Grid.Col offset={isMobile ? 0 : 1} span={isMobile ? 12 : 10} style={{ borderRadius: '10px', padding: '20px' }}>
                                <Grid>
                                    <Grid.Col span={isMobile ? 12 : 5}>
                                        <Text fw={500} c={'red'} opacity={0.7}>**Chaning the Po no will just rename the po no.**</Text>
                                        <div className={classes.rowSection}>
                                            <div className={classes.title}>
                                                <Text fw={650}>Po No</Text>
                                            </div>
                                            <TextInput
                                                variant='unstyle'
                                                placeholder='Po No'
                                                value={allocation.po_no}
                                                style={{ flexGrow: 1 }}
                                                onChange={(e) => setAllocation({ ...allocation, po_no: e.target.value.toUpperCase() })}
                                            />
                                        </div>
                                    </Grid.Col>
                                    <Grid.Col span={isMobile ? 12 : 5}>
                                        <Text fw={500} c={'red'} opacity={0.7}>**Changing style no updates it in all related POs.**</Text>
                                        <div className={classes.rowSection}>
                                            <div className={classes.title}>
                                                <Text fw={650}>Style No</Text>
                                            </div>
                                            <TextInput
                                                variant='unstyle'
                                                placeholder='Style No'
                                                value={allocation.style_no}
                                                style={{ flexGrow: 1 }}
                                                onChange={(e) => setAllocation({ ...allocation, style_no: e.target.value.toUpperCase() })}
                                            />
                                        </div>
                                    </Grid.Col>
                                    <Grid.Col span={isMobile ? 12 : 2}>
                                        <Text fw={500} c={'white'} opacity={0.7}>{` -`}</Text>
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <Button onClick={handleSave} style={{ width: isMobile ? '50%' : '100%' }} className={classes.bottomBtn} ><IconDeviceFloppy /> Save</Button>
                                        </div>
                                    </Grid.Col>
                                </Grid>
                                <Grid>
                                    <Grid.Col span={isMobile ? 12 : 5}>
                                        <div>
                                            <div className={classes.rowSection} >
                                                <div className={classes.title} style={{ width: '40%' }}>
                                                    <Text fw={650}>Add store</Text>
                                                </div>
                                                <Select
                                                    searchable
                                                    clearable
                                                    variant='unstyled'
                                                    data={STORES.filter((store: string) => !allocation.storeName?.includes(store))}
                                                    placeholder='Add store...'
                                                    className={classes.selectStore}
                                                    onChange={(value) => handleStoreChange(value || '')}
                                                />
                                                <IconPlus className={classes.plusIcon} onClick={handleAddStore} />
                                            </div>
                                            <div className={classes.tableStore}>
                                                <Table withTableBorder withColumnBorders stickyHeader >
                                                    <Table.Thead className={classes.tableHead}>
                                                        <Table.Tr>
                                                            <Table.Th style={{ textAlign: 'center' }}>Stores</Table.Th>
                                                        </Table.Tr>
                                                    </Table.Thead>
                                                    <Table.Tbody>
                                                        {allocation.storeName?.map((store: string, index: number) => {
                                                            return (
                                                                <Table.Tr>
                                                                    <Table.Td style={{ textAlign: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                                        <Text>{index + 1}</Text> {store} <IconTrash className={classes.trashIcon} onClick={() => handleDeleteStore(store, index)} />
                                                                    </Table.Td>
                                                                </Table.Tr>)
                                                        })}
                                                    </Table.Tbody>
                                                </Table>
                                            </div>
                                        </div>
                                    </Grid.Col>
                                    <Grid.Col span={isMobile ? 12 : 7}>
                                        <div>
                                            <div className={classes.rowSection}>
                                                <div className={classes.title} style={{ width: '40%' }}>
                                                    <Text fw={650}>Add size</Text>
                                                </div>
                                                <div>
                                                    <TextInput
                                                        type='number'
                                                        variant='unstyle'
                                                        placeholder='Index'
                                                        className={classes.selectStore}
                                                        onChange={(e) => setSizeData(prev => ({ ...prev, index: parseInt(e.target.value) }))}
                                                    />
                                                </div><div style={{ borderLeft: '1px solid black' }}>
                                                    <TextInput
                                                        placeholder='Add Size...'
                                                        variant='unstyle'
                                                        className={classes.selectStore}
                                                        onChange={(e) => setSizeData(prev => ({ ...prev, size: e.target.value }))}
                                                    />
                                                </div><div style={{ borderLeft: '1px solid black' }}>
                                                    <TextInput
                                                        type='number'
                                                        placeholder='Quantity'
                                                        variant='unstyle'
                                                        className={classes.selectStore}
                                                        onChange={(e) => setSizeData(prev => ({ ...prev, quantity: parseInt(e.target.value) }))}
                                                    />
                                                </div>
                                                <IconPlus className={classes.plusIcon} onClick={() => handleAddSize()} />
                                            </div>
                                            <div className={classes.tableStore}>
                                                <Table withTableBorder stickyHeader >
                                                    <Table.Thead className={classes.tableHead}>
                                                        <Table.Tr>
                                                            <Table.Th colSpan={4} style={{ textAlign: 'center' }}>Sizes</Table.Th>
                                                        </Table.Tr>
                                                    </Table.Thead>
                                                    <Table.Tbody>
                                                        <Table.Tr>
                                                            <Table.Th>No</Table.Th>
                                                            <Table.Th>Size</Table.Th>
                                                            <Table.Th>QTY</Table.Th>
                                                            <Table.Th>Delete</Table.Th>
                                                        </Table.Tr>
                                                        {allocation.receivedQty?.map((item: { size: string, quantity: number }, index: number) => {
                                                            return (
                                                                <Table.Tr>
                                                                    <Table.Td style={{ textAlign: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                                        {index + 1}
                                                                    </Table.Td>
                                                                    <Table.Td>
                                                                        <div style={{ backgroundColor: theme.colors.gray[0], padding: '3px', width: '70px' }}>
                                                                            <TextInput variant='unstyle' value={item.size} onChange={(e) => handleEditSize(e.target.value, index)} />
                                                                        </div>
                                                                    </Table.Td>
                                                                    <Table.Td>
                                                                        {item.quantity}
                                                                    </Table.Td>
                                                                    <Table.Td>
                                                                        <IconTrash className={classes.trashIcon} onClick={() => handleDeleteSize(item.size, item.quantity, index)} />
                                                                    </Table.Td>
                                                                </Table.Tr>)
                                                        })}
                                                    </Table.Tbody>
                                                </Table>
                                            </div>
                                        </div>
                                    </Grid.Col>
                                </Grid>
                            </Grid.Col>
                        </Grid></div>)}
                </div>
            </div >
            <div className={'footerDiv'}>
            </div>
        </div >
    )
}


export default ModifyAllocation;